import {useRegisterSW} from "virtual:pwa-register/react";
import {Modal} from "@ui";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import {useBrandTitle} from "../../../util/logoUtils";

const intervalMS = 60 * 60 * 1000;

const UpdatePrompt = () => {
  const brandTitle = useBrandTitle();

  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(swUrl, r) {
      r &&
        setInterval(async () => {
          if (r.installing || !navigator) {
            return;
          }

          if ("connection" in navigator && !navigator.onLine) {
            return;
          }

          const resp = await fetch(swUrl, {
            cache: "no-store",
            headers: {
              cache: "no-store",
              "cache-control": "no-cache",
            },
          });

          if (resp?.status === 200) {
            await r.update();
          }
        }, intervalMS);
    },
    onRegisterError(_error) {},
  });

  const handleUpdate = () => {
    updateServiceWorker(true);
    setNeedRefresh(false);
  };

  const handleCancel = () => {
    setNeedRefresh(false);
  };

  return (
    <Modal
      title="Actualización Disponible"
      open={needRefresh}
      footer={[
        <PrimaryButton
          key="update"
          onClick={() => handleUpdate()}
        >
          Actualizar Ahora
        </PrimaryButton>,
        <SecondaryButton
          key="cancel"
          onClick={() => handleCancel()}
        >
          Actualizar Luego
        </SecondaryButton>,
      ]}
    >
      <p style={{color: "var(--text-primary)"}}>
        Una nueva version de {brandTitle} esta disponible. Quieres actualizar ahora?
      </p>
    </Modal>
  );
};

export default UpdatePrompt;
